import React from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServiceNowConsultingSlider = ({ consultingData }) => {
    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            mode: "free-snap",

            slides: {
                perView: 1,
                spacing: 24,
            },

            breakpoints: {
                "(min-width: 640px)": {
                    slides: {
                        perView: 2,
                        spacing: 24,
                    },
                },

                "(min-width: 1024px)": {
                    slides: {
                        perView: 3,
                        spacing: 32,
                    },
                },
            },
        },

        [
            (slider) => {
                let timeout;
                let mouseOver = false;

                function clearNextTimeout() {
                    clearTimeout(timeout);
                }

                function nextTimeout() {
                    clearTimeout(timeout);

                    if (mouseOver) return;

                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }

                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });

                    slider.container.addEventListener("mouseout", () => {
                        mouseOver = false;
                        nextTimeout();
                    });

                    nextTimeout();
                });

                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full bg-[#FFFFFF] pb-[80px] lg:pb-[100px] select-none overflow-hidden relative z-10 text-left">

            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px] flex flex-col gap-12">

                {/* Section Heading */}
                <h2 className="text-[#01386A] font-sora font-[600] text-[20px] lg:text-[30px] tracking-tight">
                    ServiceNow Consulting
                </h2>


                {/* Slider */}
                <div className="relative w-full">

                    <div
                        ref={sliderRef}
                        className="keen-slider overflow-visible"
                    >

                        {consultingData.map((item) => {

                            return (
                                <div
                                    key={item.id}
                                    className="keen-slider__slide py-4 group self-start"
                                >

                                    {/* Clickable Card */}
                                    <Link
                                        to={item.link}
                                        className="
                                            block
                                            w-full
                                            h-[200px]
                                            group-hover:h-[350px]
                                            rounded-none
                                            p-6
                                            sm:p-8
                                            flex
                                            flex-col
                                            relative
                                            overflow-hidden
                                            cursor-pointer
                                            bg-[#F0F0F0]
                                            transition-[height]
                                            duration-500
                                            ease-in-out
                                            no-underline
                                        "
                                    >

                                        {/* Blue Hover Background */}
                                        <div
                                            className="
                                                absolute
                                                inset-x-0
                                                bottom-0
                                                h-0
                                                bg-[#01386A]
                                                z-0
                                                transition-all
                                                duration-500
                                                ease-out
                                                group-hover:h-full
                                            "
                                        />


                                        {/* Title */}
                                        <div className="w-full relative z-10 pointer-events-none">

                                            <h3
                                                className="
                                                    font-sora
                                                    font-[600]
                                                    text-[16px]
                                                    sm:text-[20px]
                                                    leading-[1.3]
                                                    tracking-tight
                                                    text-[#01386A]
                                                    group-hover:text-white
                                                    transition-colors
                                                    duration-300
                                                "
                                            >
                                                {item.title}
                                            </h3>

                                        </div>


                                        {/* Description + Bottom Graphic */}
                                        <div
                                            className="
                                                w-full
                                                flex
                                                flex-col
                                                relative
                                                z-10
                                                pointer-events-none
                                                mt-5
                                            "
                                        >

                                            {/* Description */}
<p
    className="
        font-graphik
        text-[14px]
        sm:text-[16px]
        leading-relaxed
        font-[500]
        text-transparent
        group-hover:text-white/90
        max-h-0
        overflow-hidden
        opacity-0
        group-hover:opacity-100
        group-hover:max-h-[200px]
        transition-all
        duration-500
        ease-in-out
        
        mt-[50px]
    "
>
    {item.desc}
</p>                                     {/* Bottom Graphic */}
                                            <div
                                                className="
                                                    flex
                                                    items-center
                                                    justify-between
                                                    w-full
                                                    min-h-[14px]
                                                    mt-5
                                                "
                                            >

                                                <img
                                                    src="/assets/mumbai/wrap1.svg"
                                                    alt=""
                                                    className="
                                                        transition-all
                                                        duration-300
                                                        group-hover:brightness-0
                                                        group-hover:invert
                                                    "
                                                />

                                           

                                            </div>

                                        </div>

                                    </Link>

                                </div>
                            );
                        })}

                    </div>

                </div>


                {/* Slider Navigation */}
                <div className="flex items-center gap-4 mt-4 justify-start">

                    {/* Previous Button */}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            instanceRef.current?.prev();
                        }}
                        className="
                            w-11
                            h-11
                            rounded-full
                            border
                            border-[#EA6B24]
                            flex
                            items-center
                            justify-center
                            text-[#EA6B24]
                            bg-transparent
                            hover:bg-[#EA6B24]
                            hover:text-white
                            transition-all
                            duration-300
                            cursor-pointer
                            outline-none
                        "
                        aria-label="Previous service"
                    >
                        <ArrowLeft
                            size={18}
                            strokeWidth={2.5}
                        />
                    </button>


                    {/* Next Button */}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            instanceRef.current?.next();
                        }}
                        className="
                            w-11
                            h-11
                            rounded-full
                            border
                            border-[#EA6B24]
                            flex
                            items-center
                            justify-center
                            text-[#EA6B24]
                            bg-transparent
                            hover:bg-[#EA6B24]
                            hover:text-white
                            transition-all
                            duration-300
                            cursor-pointer
                            outline-none
                        "
                        aria-label="Next service"
                    >
                        <ArrowRight
                            size={18}
                            strokeWidth={2.5}
                        />
                    </button>

                </div>

            </div>

        </section>
    );
};

export default ServiceNowConsultingSlider;